import { render, staticRenderFns } from "./HotelsSearchWrapper.vue?vue&type=template&id=4c5a7486&"
import script from "./HotelsSearchWrapper.vue?vue&type=script&lang=ts&setup=true&"
export * from "./HotelsSearchWrapper.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./HotelsSearchWrapper.vue?vue&type=style&index=0&id=4c5a7486&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports